module.exports = __webpack_public_path__ + "assets/HypotenuseAndLeg.504647f003a90d9d62525b845e103aa6.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/HypotenuseAndLeg.gmt
// module id = 956
// module chunks = 0